import { WorkspaceInvitation, WorkspaceRoleSchema } from "@supernova-studio/model";
import { z } from "zod";

export const DTOWorkspaceInvitationInput = z.object({
  email: z.string().email(),
  role: WorkspaceRoleSchema,
});

export const DTOWorkspaceInvitationsListInput = z.object({
  invites: DTOWorkspaceInvitationInput.array().max(100),
  designSystemId: z.string().optional(),
});

export const DTOWorkspaceInvitationsResponse = z.object({
  invitations: WorkspaceInvitation.array(),
});

export const DTOWorkspaceInviteUpdate = z.object({
  role: WorkspaceRoleSchema,
});

export const DTOWorkspaceInvitationUpdateResponse = z.object({
  invitation: WorkspaceInvitation,
});

export type DTOWorkspaceInvitationInput = z.infer<typeof DTOWorkspaceInvitationInput>;
export type DTOWorkspaceInvitationsListInput = z.infer<typeof DTOWorkspaceInvitationsListInput>;
export type DTOWorkspaceInvitationsResponse = z.infer<typeof DTOWorkspaceInvitationsResponse>;
export type DTOWorkspaceInviteUpdate = z.infer<typeof DTOWorkspaceInviteUpdate>;
export type DTOWorkspaceInvitationUpdateResponse = z.infer<typeof DTOWorkspaceInvitationUpdateResponse>;
